import { t } from "@lingui/macro";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  CalendarCheckIcon,
  CloseIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

const CONFIRMATION_ICON_SIZE = 72;
const CONFIRMATION_ICON_RADIUS = CONFIRMATION_ICON_SIZE / 2;
const CONFIRMATION_GLYPH_SIZE = 28;
const CONFIRMATION_GLYPH_RADIUS = CONFIRMATION_GLYPH_SIZE / 2;

type Props = {
  eventName: string;
  isOpen: boolean;
  onClose: () => void;
  onGoHome: () => void;
  onViewEventPage: () => void;
};

export const EventSignupConfirmationModal = ({
  eventName,
  isOpen,
  onClose,
  onGoHome,
  onViewEventPage,
}: Props) => {
  return (
    <StandardModal
      hideCloseButton
      allowShrink
      isOpen={isOpen}
      onClose={onClose}
      backgroundColorOverride="surface-secondary"
      content={
        <VStack
          flex={1}
          height="100%"
          p={6}
          alignItems="center"
          gap={4}
          backgroundColor="surface-secondary"
          testID="event-signup-confirmation-modal"
        >
          <Box position="absolute" top={16} left={16}>
            <Button
              variant="secondary"
              size="small"
              onPress={onClose}
              accessibilityLabel={t`Close Event Signup Confirmation Modal`}
              testID="event-signup-confirmation-close-button"
            >
              <CloseIcon />
            </Button>
          </Box>

          <Box
            alignItems="center"
            justifyContent="center"
            width={CONFIRMATION_ICON_SIZE}
            height={CONFIRMATION_ICON_SIZE}
            marginTop={2}
            backgroundColor="surface-primary"
            shadowColor="icon-primary"
            shadowOffset={{ width: 0, height: 16 }}
            shadowOpacity={0.3}
            shadowRadius={48}
            style={{
              borderRadius: CONFIRMATION_ICON_RADIUS,
              overflow: "hidden",
            }}
          >
            <Box
              alignItems="center"
              justifyContent="center"
              width={CONFIRMATION_GLYPH_SIZE}
              height={CONFIRMATION_GLYPH_SIZE}
              backgroundColor="surface-main-primary-neutral"
              style={{
                borderRadius: CONFIRMATION_GLYPH_RADIUS,
              }}
            >
              <CalendarCheckIcon color="button-main-icon" />
            </Box>
          </Box>

          <VStack alignItems="center" gap={2} width="100%">
            <Text variant="mainTitle3" textAlign="center">
              {t`You are in the event!`}
            </Text>
            <Text variant="mainSmallMedium" textAlign="center" maxWidth={240}>
              {t`You've successfully joined ${eventName}`}
            </Text>
          </VStack>

          <HStack gap={4} width="100%" padding={2}>
            <Button
              style={{ flex: 1 }}
              variant="outline"
              size="small"
              onPress={onViewEventPage}
              accessibilityLabel={t`View Event Page`}
              testID="event-signup-confirmation-view-event-button"
            >
              {t`View Event Page`}
            </Button>
            <Button
              style={{ flex: 1 }}
              variant="main"
              size="small"
              onPress={onGoHome}
              accessibilityLabel={t`Go back Home`}
              testID="event-signup-confirmation-go-home-button"
            >
              {t`Go back Home`}
            </Button>
          </HStack>
        </VStack>
      }
    />
  );
};
